<template>
  <div>
    <p class="h4">{{ titre }}</p>
    <div class="checkbox-wrapper">
      <input type="checkbox" @input="$emit('input', $event.target.checked)" :id="idCheckbox" :checked="possedeQualification">
      <label :for="idCheckbox">{{ label }}</label>
    </div>
    <label v-if="possedeQualification" :for="idTextarea">{{ labelTextArea }}</label>
    <textarea v-if="possedeQualification" :value="qualification" @input="$emit('textarea', $event.target.value)" :id="idTextarea"></textarea>
  </div>
</template>

<script>
export default {
  name: 'qualification',
  props: [
    'id',
    'titre',
    'label',
    'possedeQualification',
    'qualification',
    'labelTextArea'
  ],
  computed: {
    idCheckbox() {
      return 'possedeQualification' + this.id;
    },
    idTextarea() {
      return 'qualification' + this.id;
    }
  }
}
</script>

<style scoped>
textarea {
  width: 90%;
  height: 9rem;
}
</style>